module.exports = __webpack_public_path__ + "static/media/level1-2.1353bb76.mp3";